module.exports = __webpack_public_path__ + "assets/img/98c099d6d17b0874a7a598bf86ae444a.svg";